// extracted by mini-css-extract-plugin
export var clientLogo = "Intro-module--clientLogo--b1efd";
export var clientsList = "Intro-module--clientsList--22fb8";
export var column = "Intro-module--column--914ce";
export var container = "Intro-module--container--c5568";
export var fadeInAnimation = "Intro-module--fadeInAnimation--9896a";
export var form = "Intro-module--form--22620";
export var formWrap = "Intro-module--formWrap--5d1b5";
export var headerPlaceholder = "Intro-module--headerPlaceholder--e4287";
export var mobileTitles = "Intro-module--mobileTitles--cf348";
export var picture = "Intro-module--picture--2f6b0";
export var pictureImage = "Intro-module--pictureImage--2957d";
export var steps = "Intro-module--steps--58c4c";
export var title = "Intro-module--title--a80ab";
export var wrapper = "Intro-module--wrapper--69192";